import { useState } from "react";
import {
  _set_channel,
  set_checkout_id,
  set_cid,
  set_cpid,
  _set_channel_claimed,
  _set_pending_channel,
  _set_pending_cid,
  _set_pending_cpid,
} from "../../../store/actions/login_actions";
import PromoHig from "../../../assets/images/data/hig-popup.webp";
import PromoMuscat from "../../../assets/images/data/HiMuscat.webp";
import PromoLogo from "../../../assets/images/data/PromoLogo.webp";
import { ReactComponent as ArrowDown } from "../../../assets/svg/arrow-down-icon.svg";
import styles from "./PromoModal.module.scss";
import LoginPromo from "./LoginPromo";
import OTPPromo from "./OTPPromo";
import { useDispatch, useSelector } from "react-redux";
import { Trans, useTranslation } from "react-i18next";
import { Button } from "antd";
import {
  set_carwash_expanded,
  set_carwash_visible,
} from "../../../store/actions/popup_actions";
import { _Cart_Clean } from "../../../store/actions/cart_actions";
import { showAllErrors } from "../../../base/utils";
import { BaseChannel } from "../../../base/env";
import { ValidLoginMutation } from "../../../graphql/none_saleor/auth/auth";
import { useMutation } from "@apollo/client";
import SwitchLanguage from "../switchlanguage/switchLanguage";

const PromoModal = () => {
  const [step, setStep] = useState("phone");
  const [availableOtp, setAvailableOtp] = useState([]);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [validLoginMutation] = useMutation(ValidLoginMutation, {
    context: { clientName: "auth" },
  });

  const {
    is_login,
    cid,
    cpid,
    channel,
    pendingCid,
    pendingCpid,
    pendingChannel,
    country_code,
    phone_number,
  } = useSelector((state) => state.Login);

  const { carwashPopupVisible, carwashPopupExpanded } = useSelector(
    (state) => state.Popup,
  );


  const effectiveCid = pendingCid || cid;
  const effectiveCpid = pendingCpid || cpid;


  const shouldShow =
    carwashPopupVisible && (pendingChannel || pendingCid || pendingCpid);

  if (!shouldShow) return null;

  if (effectiveCpid === "gmall") return null;

 
  const setIsVisible = (status) => {
    dispatch(set_carwash_visible(status));
  };

  const setIsExpanded = (status) => {
    dispatch(set_carwash_expanded(status));
  };

  return (
    <>
      {carwashPopupExpanded && (
        <div
          className={styles.backdrop}
          onClick={() => setIsExpanded(false)}
          onTouchMove={(e) => e.preventDefault()}
        />
      )}

      <div
        className={`${styles.promoModalWrapper} ${
          carwashPopupExpanded ? styles.expanded : ""
        }`}
        data-login={is_login}
        data-cpid={effectiveCpid}
        onClick={!carwashPopupExpanded ? () => setIsExpanded(true) : undefined}
      >
        <div
          className={`${styles.promoModalInner} ${
            carwashPopupExpanded ? styles.expanded : ""
          }`}
          data-login={is_login}
        >
          {/* collapsed */}
          {!carwashPopupExpanded && (
            <div className={styles.closedModalContent}>
              <div className={styles.modalTitle}>
                <div className={styles.closedContent}>
                  <p className={styles.closedContentP}>
                    {t(`${effectiveCpid}.title`)}
                  </p>
                  <span className={styles.expirationDate}>
                    <Trans
                      i18nKey={`${effectiveCpid}.date`}
                      components={{ br: <br />, bold: <strong /> }}
                      className={styles.expirationDate}
                    />
                  </span>
                </div>
              </div>

              <button
                type="button"
                className={styles.removeButton}
                onClick={(e) => {
                  e.stopPropagation();
                  setIsExpanded(true);
                }}
              >
                <ArrowDown />
              </button>
            </div>
          )}

          {/* expanded */}
          {carwashPopupExpanded && (
            <div className={styles.expandedContent}>
              <div>
                <button
                  type="button"
                  className={styles.closeButton}
                  onClick={(e) => {
                    e.stopPropagation();
                    setIsExpanded(false);
                  }}
                >
                  <ArrowDown />
                </button>

                <span className={styles.LangWrapper}>
                  <SwitchLanguage />
                </span>

                <img
                  src={effectiveCpid === "himuscat" ? PromoMuscat : PromoHig}
                  style={{
                    width: "100%",
                    marginBlockStart: 8,
                    marginBlockEnd: 8,
                    height: "85px",
                  }}
                  alt="promo banner"
                />

                {effectiveCpid !== "gmall" && (
                  <img
                    src={PromoLogo}
                    style={{
                      width: "100%",
                      marginBlockStart: 16,
                      marginBlockEnd: 24,
                      height: "37px",
                    }}
                    alt="promo banner"
                  />
                )}

                <p className={styles.expandedDesc}>
                  <Trans
                    i18nKey={`${effectiveCpid}.description`}
                    components={{ bold: <strong /> }}
                  />
                </p>
                {effectiveCpid !== "gmall" && (
                  <p className={styles.expirationTitle}>
                    <Trans
                      i18nKey={`${effectiveCpid}.date`}
                      components={{ br: <br />, bold: <strong /> }}
                      className={styles.expirationDate}
                    />
                  </p>
                )}
                {effectiveCpid !== "gmall" && (
                  <div className={styles.dashedLine} data-login={is_login} />
                )}
              </div>

              {is_login ? (
                <Button
                  size="large"
                  type="primary"
                  htmlType="button"
                  // loading={loading}
                  onClick={() => {
                    validLoginMutation({
                      variables: {
                        channelSlug: pendingChannel || channel,
                        phoneNumber: phone_number,
                        countryCode: country_code,
                        cid: effectiveCid || null,
                        cpid: effectiveCpid,
                      },
                      onCompleted: (response) => {
                        if (response?.validLogin?.errors?.length > 0) {
                          showAllErrors(response.validLogin.errors);
                          const hasCidError = response.validLogin.errors.some(
                            (err) => err.field === "cid",
                          );
                          if (hasCidError) {
                            localStorage.removeItem('cid');
                            localStorage.removeItem('cpid');
                            localStorage.removeItem('channel');
                            dispatch(set_cid(''));
                            dispatch(set_cpid('gmall'));
                            dispatch(_set_channel(BaseChannel, channel));
                            dispatch(_set_pending_channel(''));
                            dispatch(_set_pending_cpid(''));
                            dispatch(_set_pending_cid(''));
                            dispatch(_Cart_Clean());
                            dispatch(set_checkout_id({ checkout_id: "" }));
                          }
                          setIsVisible(false);
                        } else {
                          dispatch(_Cart_Clean());
                          dispatch(set_checkout_id({ checkout_id: "" }));
                          dispatch(
                            _set_channel_claimed(
                              pendingChannel || channel,
                              pendingCpid || cpid,
                              pendingCid || cid,
                              channel
                            ),
                          );
                          setIsVisible(false);
                        }
                      },
                    });
                  }}
                  style={{ width: "100%", marginTop: 18 }}
                >
                  {t(`gmall.button`)}
                </Button>
              ) : (
                <div
                  style={{
                    height: "100px",
                    width: "100%",
                    marginBlockStart: "14px",
                  }}
                >
                  {step === "phone" ? (
                    <LoginPromo
                      setStep={setStep}
                      setAvailableOtp={setAvailableOtp}
                    />
                  ) : step === "otp" ? (
                    <OTPPromo
                      setStep={setStep}
                      availableOtp={availableOtp}
                      setIsVisible={setIsVisible}
                    />
                  ) : null}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default PromoModal;
